import {customElement, property, query} from 'lit/decorators.js';
import {FlywheelComponent} from '@gl/lit/lib/component.js';
import {ImmutableComponent} from '@gl/lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '@gl/lit/types/classes.js';
import type {Model} from './architecture.js';
import {Msg, main} from './architecture.js';
import type {
  TypefaceEmbedUseCase,
  TypefaceEmbedOutputFormat,
  TemplateParameters,
} from '@typeface-ai/typeface-embed-react/lib/esm/model.js';

import styles from './style.scss';

export const TYPEFACE_MODAL_ELEMENT_TAG = 'typeface-modal';

/**
 * Generic modal interfacing with Typeface iframe SDK.
 * Emits an "applied" or "cancelled" event based on iframe interaction.
 */
@customElement(TYPEFACE_MODAL_ELEMENT_TAG)
export default class TypefaceModal extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({component: FlywheelComponent, main}) {
  @property({type: Boolean}) open = false;
  @property({type: Object}) parameters?: Model['parameters'];
  @property() useCase?: TypefaceEmbedUseCase;
  @property() output?: TypefaceEmbedOutputFormat;

  @query('#typeface-iframe') $iframe?: HTMLIFrameElement;

  toggle(parameters: TemplateParameters) {
    this.setParameters(parameters);
    if (this.open) {
      this.handleUpdate(Msg.close());
    } else {
      this.handleUpdate(Msg.open());
    }
  }

  reload() {
    if (!this.$iframe) return;
    // Hack for forcing a proper reload of the iframe.
    /* eslint-disable-next-line no-self-assign */
    this.$iframe.src = this.$iframe.src;
  }

  setParameters(params: TemplateParameters) {
    this.handleUpdate(Msg.setParameters(params));
  }

  static get styles() {
    return [styles];
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [TYPEFACE_MODAL_ELEMENT_TAG]: TypefaceModal;
  }
}
